import * as React from 'react';
import { Radio, ControlLabel, FormControl, FormGroup, Row, Checkbox } from 'react-bootstrap';

interface IProps {
    recpMrn: string,
    recpFirstName: string,
    recpLastName: string,
    recpGender: string,
    recpDob: string,
    recpHasRecentTransplant: boolean,
    recpRecentTransplantDate: string,
    recpMedicareNumber: string,
    handleGenderSelect: (e: boolean) => void,
    handleInputChange: (e: React.FormEvent<FormControl & HTMLInputElement>) => void,
    handleRecentTransplantToggle: (e: React.FormEvent<FormControl & HTMLInputElement>) => void
}

class RecipientAddressInfo extends React.Component<IProps> {
    render = () => {
        let isMale = this.props.recpGender == 'M' ? true : false;

        return (
            <div className='col-sm-12'>
                <Row>
                    <div className='col-sm-4'>
                        <FormGroup>
                            <ControlLabel>First Name</ControlLabel>
                            <FormControl
                                type="text"
                                name="recpFirstName"
                                value={this.props.recpFirstName}
                                placeholder="First Name"
                                onChange={this.props.handleInputChange}
                            />
                            <FormControl.Feedback />
                        </FormGroup>
                    </div>
                    <div className='col-sm-4'>
                        <FormGroup>
                            <ControlLabel>Last Name</ControlLabel>
                            <FormControl
                                type="text"
                                name="recpLastName"
                                value={this.props.recpLastName}
                                placeholder="First Name"
                                onChange={this.props.handleInputChange}
                            />
                            <FormControl.Feedback />
                        </FormGroup>
                    </div>
                    <div className='col-sm-4'>
                        <ControlLabel>Date of Birth</ControlLabel>
                        <FormControl
                            type='date'
                            name='recpDob'
                            value={this.props.recpDob}
                            onChange={this.props.handleInputChange}
                        />
                    </div>
                </Row>
                
                <Row>
                    
                    <div className='col-sm-4'>
                        <ControlLabel>Gender</ControlLabel>
                        <FormGroup 
                            name='recpGender'
                            value={this.props.recpGender}>
                            <Radio name="radioGroup" checked={isMale} 
                        onClick={() => this.props.handleGenderSelect(true)} inline>
                                Male
                            </Radio>{' '}
                            <Radio name="radioGroup" checked={!isMale} 
                            onClick={() => this.props.handleGenderSelect(false)} inline>
                                Female
                            </Radio>{' '}
                        </FormGroup>
                    </div>

                    <div className='col-sm-4'>
                        <FormGroup controlId="addressText">
                            <ControlLabel>Medicare Number</ControlLabel>
                            <FormControl
                                type="text"
                                name="recpMedicareNumber"
                                value={this.props.recpMedicareNumber}
                                placeholder="Enter Medicare Number"
                                onChange={this.props.handleInputChange}
                            />
                            <FormControl.Feedback />
                        </FormGroup>
                    </div>
                    <div className='col-sm-4'>
                        <FormGroup controlId="recpMrn">
                            <ControlLabel>MRN #</ControlLabel>
                            <FormControl
                                type="text"
                                name="recpMrn"
                                value={this.props.recpMrn}
                                placeholder="Enter MRN"
                                onChange={this.props.handleInputChange}
                            />
                            <FormControl.Feedback />
                        </FormGroup>
                    </div>
                    
                </Row>

                <Row>
                    <div className='col-sm-4'>
                        <FormGroup>
                            <ControlLabel>Had a Recent Transplant?</ControlLabel>
                            <Checkbox onChange={this.props.handleRecentTransplantToggle} name='months1'>Yes</Checkbox>
                        </FormGroup>
                    </div>

                    {this.props.recpHasRecentTransplant
                        &&
                        <div className='col-sm-8'>
                            <FormGroup>
                                <ControlLabel>Most Recent Transplant</ControlLabel>
                                <FormControl
                                    type='date'
                                    name='recpRecentTransplantDate'
                                    value={this.props.recpRecentTransplantDate}
                                    onChange={this.props.handleInputChange}
                                />
                            </FormGroup>
                        </div>
                    }
                </Row>
            </div>
        )
    }
}

export default RecipientAddressInfo;